import * as z from "zod";

export const getMerchantZonosIntegration = {
  name: "getMerchantZonosIntegration" as const,
  input: z.object({}),
  output: z.object({ available: z.boolean(), connected: z.boolean() }),
};
